import React from 'react';
import { THEME } from './theme';

// Legend overlay (addendum 9): Received (green up-arc glyph), Sent (purple
// down-arc glyph), and In the mail now with a marching-dash glyph when there is
// anything in the mail. Desktop top-left, phone compact bottom-left (CSS).

interface Props {
  inTransit: number;
  compact?: boolean;
}

const Bow: React.FC<{ color: string; up: boolean }> = ({ color, up }) => (
  <svg width="18" height="10" viewBox="0 0 18 10" aria-hidden>
    <path d={up ? 'M1 8 Q9 -3 17 8' : 'M1 2 Q9 13 17 2'} fill="none" stroke={color} strokeWidth="1.75" strokeLinecap="round" />
  </svg>
);

const TradeMapLegend: React.FC<Props> = ({ inTransit, compact = false }) => (
  <div className={`ptm-legend${compact ? ' ptm-legend--compact' : ''}`} data-testid="ptm-legend">
    <span className="ptm-legend-item">
      <Bow color={THEME.inbound} up />
      Received
    </span>
    <span className="ptm-legend-item">
      <Bow color={THEME.outbound} up={false} />
      Sent
    </span>
    {inTransit > 0 && (
      <span className="ptm-legend-item" data-testid="ptm-legend-live">
        <svg width="18" height="10" viewBox="0 0 18 10" aria-hidden>
          <path d="M1 5 H17" fill="none" stroke={THEME.inbound} strokeWidth="2" strokeLinecap="round" strokeDasharray="3 3" />
        </svg>
        In the mail now · {inTransit.toLocaleString('en-US')}
      </span>
    )}
  </div>
);

export default TradeMapLegend;
